var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.666 36.6668H29.9993C30.8834 36.6668 31.7312 36.3157 32.3564 35.6905C32.9815 35.0654 33.3327 34.2176 33.3327 33.3335V13.3335C33.334 12.8054 33.2307 12.2822 33.0287 11.7942C32.8268 11.3061 32.5301 10.863 32.156 10.4902L26.176 4.51017C25.8032 4.13604 25.36 3.83944 24.872 3.63748C24.384 3.43552 23.8608 3.33221 23.3327 3.33351H9.99935C9.11529 3.33351 8.26745 3.6847 7.64233 4.30982C7.0172 4.93494 6.66602 5.78279 6.66602 6.66684V11.4168",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.334 3.3335V11.6668C23.334 12.1089 23.5096 12.5328 23.8221 12.8453C24.1347 13.1579 24.5586 13.3335 25.0007 13.3335H33.334",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 23.3335V27.0002L16.0007 28.6668",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 36.6665C18.8568 36.6665 23.334 32.1894 23.334 26.6665C23.334 21.1437 18.8568 16.6665 13.334 16.6665C7.81114 16.6665 3.33398 21.1437 3.33398 26.6665C3.33398 32.1894 7.81114 36.6665 13.334 36.6665Z",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentHistory);
export default __webpack_public_path__ + "static/media/document-history.6ec6aa507f91a29810be90ae2e5f1cdd.svg";
export { ForwardRef as ReactComponent };